// Runtime configuration.
//
// `apiUrl` starts with the local-development default. In deployed
// environments it is overwritten at app startup by AppConfigService, which
// reads /assets/config.json — a file generated by the container entrypoint
// from the API_URL environment variable. This keeps a SINGLE frontend image
// reusable across every environment (fitroom, fussion, ...) without rebuilds.
export const environment = {
  production: false,
  // Overwritten at runtime by AppConfigService when /assets/config.json is present.
  // You should use the IP when testing the fingerprint. example: 'http://192.168.100.34:8080/fit-room-gym/api'
  apiUrl: 'http://localhost:8080/fit-room-gym/api',
};
